export const wishlistCardActions = self => ({
    init: data => {
        self.contactFirstName = data.contactFirstName;
        self.contactLastName = data.contactLastName;
        self.contactCompany = data.contactCompany;
        self.contactTitle = data.contactTitle;
        self.shouldInitState = false;
        self.originalState = data.originalState;
        self.isPartialProfile = data.isPartialProfile;
    },
    set: (key, value) => {
        self[key] = value;
    },
    resetState: () => {
        self.contactFirstName = '';
        self.contactLastName = '';
        self.contactCompany = null;
        self.contactTitle = '';
        self.contactEmail = '';
        self.contactPhone = '';
        self.shouldInitState = false;
        self.isSavingToWishlist = false;
        self.isPartialProfile = false;
        self.originalState = null;
    },
});
